import { useDialog } from '../../../../hooks/use-dialog';
import type { PlanCreationPlanPreview } from '../create-plan-provider-types/plan-creation-plan-preview';

export function usePlanCreationPlanPreview(): PlanCreationPlanPreview {
  const { isDialogOpen, handleOpen, handleClose } = useDialog(true);

  return {
    open: isDialogOpen,
    show: handleOpen,
    hide: handleClose,
  };
}